const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { label: 'Home', icon: 'home' },
    children: [
      { path: '', component: () => import('pages/IndexPage.vue')},
      { path: 'tir', component: () => import('pages/TirManage.vue'),
        meta: { label: 'Тир', icon: 'gps_fixed' } },
      { path: 'tir/:id', component: () => import('pages/TirSetup.vue'),
        meta: { label: 'Настройки тира', icon: 'edit', parent: '/tir' } },
      { path: 'employee', component: () => import('pages/OperatorList.vue'),
        meta: { label: 'Операторы', icon: 'engineering' } },
      { path: 'employee/:id', component: () => import('pages/OperatorSetup.vue'),
        meta: { label: 'Редактирование', icon: 'edit', parent: '/employee' } },
      { path: 'account', component: () => import('pages/AccountList.vue'),
        meta: { label: 'Учетные записи', icon: 'person' } },
      { path: 'account/:id', component: () => import('pages/AccountEdit.vue'),
        meta: { label: 'Редактирование', icon: 'edit', parent: '/account' } },
      { path: 'profile', component: () => import('pages/ProfileEdit.vue'),
        meta: { label: 'Профиль', icon: 'edit' } },
      { path: 'tenant', component: () => import('pages/TenantList.vue'),
        meta: { label: 'Партнеры', icon: 'business' } },
      { path: 'tenant/:id', component: () => import('pages/TenantEdit.vue'),
        meta: { label: 'Редактирование', icon: 'group', parent: '/tenant' } },
      { path: 'journal', component: () => import('pages/GameJournal.vue'),
        meta: { label: 'Журнал игр', icon: 'history' } },
      { path: 'summary', component: () => import('pages/SummaryJournal.vue'),
        meta: { label: 'Сводная статистика', icon: 'history' } },
    ]
  },
  { path: '/auth', component: () => import('pages/LoginPage.vue')},
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue')
  }
]

export default routes
